<template>
  <div class="page">
    <navigation :customClickEvent="true" @click="detentionVisible=true">天美贷</navigation>
    <authBanner />
    <section class="content">
      <section class="title">
        基本信息
      </section>
      <!-- <u class="help" @click="navigateTo('/authentication/id/guide')">身份证识别遇到问题</u> -->
      <section class="picture">
        <div class="item">
          <img :src="frontImg" />
          <input ref="frontInput" type="file" accept="image/*" class="frontInput" @change="changeHandler($event, 'CARD_FRONT_PHOTO')" />
        </div>
        <div class="item">
          <img :src="backImg" />
          <input ref="backInput" type="file" accept="image/*" class="backInput" @change="changeHandler($event, 'CARD_BACK_PHOTO')" />
        </div>
      </section>
      <section class="id-info">
        <form class="form">
          <div class="form-item underline-un-focus">
            <nd-input name="name" v-model="form.name" maxLength="10" label="真实姓名" placeholder="请填写真实姓名" text-align="right" @input="nameInput">
            </nd-input>
          </div>
          <div class="form-item underline-un-focus">
            <nd-input name="idcardNumber" v-model="form.idcardNumber" maxLength="18" label="身份证号" placeholder="请填写身份证号" text-align="right" @input="idcardInput">
            </nd-input>
          </div>
          <div class="form-item underline-un-focus">
            <nd-choose name="education" v-model="form.education" :data="dictionary.educationTypes" :valueKey="['key', 'description']" label="最高学历">
            </nd-choose>
          </div>
          <div class="form-item underline-un-focus">
            <nd-choose name="marital" v-model="form.marital" :data="dictionary.maritalStatus" :valueKey="['key', 'description']" label="婚姻状况">
            </nd-choose>
          </div>
          <div class="form-item underline-un-focus">
            <nd-address name="addressSelect" v-model="form.addressSelect" :columns="3" :mutilple="true" inputStyle="width: 70%;margin-left: 30%" label="现居住地">
            </nd-address>
          </div>
          <div class="form-item underline-un-focus textarea">
            <nd-input type="textarea" name="address" v-model="form.address" text-align="left" placeholder="请输入五位以上的详细地址：如小区、楼栋号、单元等" maxLength="40" @input="addressInput">
            </nd-input>
          </div>
        </form>
      </section>
      <section class="error-info" v-show="ocrErrorVisible || errorInfoVisible">
        {{ ocrErrorInfo || errorInfo }}
      </section>
    </section>

    <nd-button class="next-step" :disabled="disabled" v-stat="{ id: 10074, args: { position: 'page_auth_identity' } }" @click="next">下一步</nd-button>

    <div class="bottom-protocol">
      <span>点击「下一步」按钮表示您已阅读并同意</span> <br />
      <span class="active" @click="checkProtocols">《用户信息授权协议》</span>
    </div>

    <detention v-model="detentionVisible" />
    <canvas id="canvas" v-show="false" width="1440" height="1080"></canvas>
  </div>
</template>

<script>
import pic01 from './images/img_f.png'
import pic02 from './images/img_b.png'
import ImageCompressor from 'image-compressor.js'
import { mapActions, mapState } from 'vuex'
import { getKey, isEmojiCharacter, setKey } from '../../assets/utils'
import { CountDown } from 'vant'
let timer = null

function debounce (fn, wait) {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
  timer = setTimeout(function () {
    fn()
  }, wait)
}

export default {
  name: 'authentication-id',

  customReadyNotify: true,

  data () {
    return {
      time: 15 * 60e3,
      show: false,
      applyNo: null,
      diversionData: {},
      detentionVisible: false,
      form: {
        orderNo: null,
        name: '',
        idcardNumber: '',
        education: '',
        marital: '',
        addressSelect: '',
        address: ''
      },
      rules: {
        address: [
          {
            require: true,
            message: '详细地址不能为空',
            trigger: 'blur'
          },
          {
            handler: (input) =>
              input.length > 5 &&
              /[\u4e00-\u9fa5][\u4e00-\u9fa5a-zA-Z0-9()（）·]+$/.test(input) &&
              !isEmojiCharacter(input),
            message: '请输入正确的居住地址',
            trigger: 'blur'
          }
        ]
      },
      frontImg: pic01,
      frontFile: '',
      backImg: pic02,
      backFile: '',
      infoVisible: false, // 身份信息可见性
      ocrErrorVisible: false,
      ocrErrorInfo: '',
      errorInfoVisible: false, // 错误信息可见性
      errorInfo: '',
      pfrom: this.$route.query.pfrom,
      currentActivity: {},
      process: '',
     
      name: null,
      idcardNumber: null,
      popupList: []
    }
  },
  components: {
    authBanner: () => import('./components/authBanner.vue'),
    detention: () => import('./components/detention.vue')
  },
  computed: {
    ...mapState({
      dictionary: (state) => state.dictionary || {},
      caseList: (state) => state.caseList,
      [CountDown.name]: CountDown
    }),

    disabled () {
      return (
        !this.checkName() ||
        !this.checkIDCard() ||
        !this.form.education ||
        !this.form.marital ||
        !this.form.addressSelect ||
        !this.checkAddress() ||
        !this.form.orderNo
      )
    },
    popConfirmTitle () {
      return this.currentActivity.activeType === 'NEW_PERSON_V2'
        ? '去拿188元'
        : '继续完成实名认证'
    },
    popCancelTitle () {
      return this.currentActivity.activeType === 'NEW_PERSON_V2'
        ? '放弃好运'
        : this.currentActivity.activeType === 'NEW_PERSON'
          ? '放弃奖励'
          : '放弃免息返现'
    }
  },

  watch: {
    // 是否照了正面
    frontFile (value) {
      if (value && this.backFile) {
        this.IDOCR()
      }
    },
    // 是否照了背面
    backFile (value) {
      if (value && this.frontFile) {
        this.IDOCR()
      }
    }
  },

  async created () {
    if (this.$route.query?.result === 'PASS') {
      console.log(123)
      await this.checkFaceResult()
    } 

    window.history.pushState({}, '', window.location.href)
    window.addEventListener('popstate', () => {
      this.detentionVisible = true
    })

    this.applyNo = getKey('isRefused')
    this.diversionData = JSON.parse(
      sessionStorage.getItem('refusedPr') || '{}'
    )
  

    await Promise.all([
      this.fetchDictionaryX()
    ])
    this.$bus.$emit('ready')
    this.ocrAddTag()
  },

  methods: {
    ...mapActions('user', ['getUserInfoX', 'ocrAddTag']),
    ...mapActions('authentication', [
      'TXOCRX',
      'preCreditApplyX',
      'verifyOcrX',
      'preCreditPopup',
      'uploadOSS',
      'fillProcessX'
    ]),
    ...mapActions('authentication', ['onlyPreApply']),
    async checkFaceResult () {
      const { success } = await this.onlyPreApply({
        creditFLowType: 'H5_CREDIT'
      })
      if (success) {
        this.$router.replace('/authentication/base-h5-credit')
      }
    },
 
    // 校验用户是否是需要去补充资料银行卡的人群
    async fillProcess () {
      const { success, data } = await this.fillProcessX()
      if (success) {
        this.process = data.process
      }
    },
    riverMiddle () {
      this.$sensors.track('Diversion_Click', {
        product_type: 'diversion',
        page_status: 'pre-credit',
        element_positon: 'product_pop',
        product_code: this.diversionData.configId
      })
      const needQueue = getKey('needQueue')
      this.$router.replace({
        path: '/river/middle',
        query: {
          directionUrl: encodeURIComponent(this.diversionData.directionUrl),
          source: encodeURIComponent(this.source),
          ...this.diversionData,
          to: 'result',
          applyNo: this.applyNo,
          needQueue
        }
      })
    },
    ...mapActions(['getCaseListX', 'fetchDictionaryX']),
    changeHandler (event, type) {
      // 此时可以自行将文件上传至服务器
      const file = event.target.files[0]
      if (file) {
        this.$indicator()
        this.compressor(file).then(async (newFile) => {
          const base64File = await this.getImgBase64(newFile)
          const params = {
            base64Str: base64File,
            fileType: type
          }
          this.uploadOSS(params).then((response) => {
            this.$indicator.close()
            if (response.success) {
              if (type === 'CARD_FRONT_PHOTO') {
                this.frontImg = URL.createObjectURL(file)
                this.frontFile = response.data
                console.log(this.frontFile)
                this.frontCoverVisible = true
                this.ocrErrorVisible = false
              } else {
                this.backImg = URL.createObjectURL(file)
                this.backFile = response.data
                this.backCoverVisible = true
                this.ocrErrorVisible = false
              }
            } else {
              this.$message('上传身份证文件失败')
            }
          })
        })
      }
    },
    // 图片压缩
    compressor (file, quality = 0.8) {
      var _this = this
      return new Promise((resolve) => {
        return new ImageCompressor(file, {
          quality: quality,
          maxWidth: 1440,
          maxHeight: 1080,
          success (result) {
            if (result.size > 2 * 1000 * 1000) {
              _this.compressor(file, quality - 0.2)
            } else {
              resolve(result)
            }
          }
        })
      })
    },
    // 图片转化为base64
    getImgBase64 (file) {
      return new Promise((resolve) => {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          let file = this.result.replace(/data:image\/\w*;base64,/, '')
          resolve(file)
        }
      })
    },
    // 置空
    empty () {
      this.form.name = null
      this.form.idcardNumber = null
      this.form.orderNo = null
      // this.infoVisible = false
      // this.errorInfoVisible = false
      // this.errorInfo = ''
      // this.ocrErrorVisible = false
      // this.ocrErrorInfo = ''
    },
    // OCR识别
    async IDOCR () {
      this.empty()
      this.$indicator('认证中')
      const params = {
        idcardFrontUrl: this.frontFile,
        idcardBackUrl: this.backFile
      }
      const response = await this.TXOCRX(params)
      this.$indicator.close()
      if (response.success) {
        if (!response.data.bizCode || response.data.bizCode === '000000') {
          // 只有身份信息识别成功才回显身份信息
          this.form.name = response.data.name
          this.form.idcardNumber = response.data.idcard
          this.form.orderNo = response.data.orderNo
          this.infoVisible = true
        } else {
          // 识别不成功
          this.$message(response.data.bizMsg)
          this.ocrErrorInfo = response.data.bizMsg
          this.ocrErrorVisible = true
          // this.$message('当前用户身份证有效期是否不足30天') // TODD小花项目
        }
      }
    },
 
   
    navigateTo (path, replace) {
      if (replace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    },
    nameInput () {
      debounce(() => {
        this.checkName(true)
      }, 500)
    },
    idcardInput () {
      debounce(() => {
        this.checkIDCard(true)
      }, 500)
    },
    addressInput () {
      debounce(() => {
        this.checkAddress(true)
      }, 500)
    },
    checkName (showError) {
      /**
       * 前端校验规则修改为只校验为空和长度
       * @author long.li
       * @date 2021年04月01日
       */
      if (!this.form.name) return false
      // if (/^[\u4e00-\u9fa5]{2,20}$/.test(this.form.name)) {
      if (this.form.name.length >= 2) {
        this.ocrErrorInfo = null
        this.ocrErrorVisible = false

        return true
      } else {
        if (showError) {
          this.ocrErrorInfo = '姓名格式错误，请重新输入'
          this.ocrErrorVisible = true
        }
        return false
      }
    },

    checkIDCard (showError) {
      /**
       * 前端校验规则修改为只校验为空和长度
       * @author long.li
       * @date 2021年04月01日
       */
      if (!this.form.idcardNumber) return false
      // if (this.form.idcardNumber.length === 18) {
      if (this.form.idcardNumber.length > 0) {
        this.ocrErrorInfo = null
        this.ocrErrorVisible = false

        return true
      } else {
        if (showError) {
          this.ocrErrorInfo = '身份证格式错误，请重新输入'
          this.ocrErrorVisible = true
        }
        return false
      }
    },

    checkAddress (showError) {
      const value = this.form.address
      if (!value) return false
      if (
        value.length > 5 &&
        /[\u4e00-\u9fa5][\u4e00-\u9fa5a-zA-Z0-9()（）·]+$/.test(value) &&
        !isEmojiCharacter(value)
      ) {
        this.errorInfo = null
        this.errorInfoVisible = false

        return true
      } else {
        if (showError) {
          this.errorInfo = '请输入正确的居住地址'
          this.errorInfoVisible = true
        }
        return false
      }
    },
    toResult () {
      if (this.process === 'NON') {
        this.$router.replace(`/authentication/result?applyNo=${this.applyNo}`)
      } else {
        this.toPreBase()
      }
    },
    toWait () {
      if (this.process === 'NON') {
        this.$router.replace(`/authentication/wait?applyNo=${this.applyNo}`)
      } else {
        this.toPreBase()
      }
    },
    toPreBase () {
      this.$router.replace(`/authentication/pre-base`)
    },
    nextApply () {
      if (getKey('needQueue')) {
        this.toWait()
      } else {
        this.toResult()
      }
    },
    async next () {
      const addressArr =
        this.form.addressSelect && this.form.addressSelect.split(/\s/)
      const addressObj = {}
      if (addressArr && addressArr.length) {
        Object.assign(addressObj, {
          province: addressArr[0],
          city: addressArr[1],
          area: addressArr[2],
          provinceCode: addressArr[3],
          cityCode: addressArr[4],
          areaCode: addressArr[5]
        })
      }
      const params = {
        loanPlatform: 'TMD',
        orderNo: this.form.orderNo,
        idCard: this.form.idcardNumber,
        name: this.form.name.replace(/\s+/g, ''),
        education: this.form.education,
        marital: this.form.marital,
        livingAddress: this.form.address,
        creditProcess: 'PRE_CREDIT_LIVING',
        creditFLowType: 'H5_CREDIT',
        ...addressObj
      }
      const res = await this.preCreditApplyX(params)
      if (res.success) {
        // 用于预授信前是否要做活体,授信活体
        if (res.data.creditLiving === 'PRE_CREDIT_LIVING') {
          this.$router.replace('/authentication/face?redirectUrl=/authentication/id-h5-credit')
          return
        }

        // 查询当前用户是否需要补充资料
        await this.fillProcess()
        // 预授信失败
        if (
          res.data &&
          res.data.preCheckResult === 'PRE_REFUSED' &&
          res.data.applyNo
        ) {
          this.applyNo = res.data.applyNo
          this.toResult()
        }

        if (res.data.needQueue) {
          setKey('needQueue', res.data.needQueue)
          this.toWait()
          return
        }
        // 认证完成后刷新用户信息
        this.getUserInfoX({ forceUpdate: true })
      
 
        this.navigateTo(`/authentication/base-h5-credit`, true)
      } else {
        this.errorInfo = res.msg
        this.errorInfoVisible = true
        this.$report({
          id: 10075,
          args: {
            succeed: 0,
            message: this.errorInfo,
            position: 'page_auth_identity'
          }
        })
        this.$statistics('OCR_FAIL', {
          comment: res.msg
        })
      }
    },
    checkProtocols () {
      setKey('authenticationForm', this.form)
      setKey('frontImg', this.frontImg)
      setKey('backImg', this.backImg)
      this.$router.push({
        path: '/protocol/authorization',
        query: {
          busiType: 'CREDIT'
        }
      })
    }
  }
}
</script>

<style scoped lang="less" src="./styles/id.less"></style>
@import "../../assets/less/mixin.less";


<style lang="less" scoped>
@import "../../assets/less/mixin.less";

/deep/.new-person-activity {
  .default-content {
    padding-top: 0;
  }
}

@keyframes curtain {
  to {
    transform: translateY(0);
  }
}

@keyframes showAffect {
  to {
    opacity: 1;
  }
}

.page {
  .content {
    .title {
      &:before {
        display: inline-block;
        content: "";
        width: 10px;
        height: 44px;
        background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
        margin-right: 10px;
      }
    }

    .picture {
      margin-top: 30px;

      .item {
        height: 230px;
      }
    }
  }

  .next-step {
    margin-bottom: 10px;
  }

  .bottom-protocol {
    background: none;
    font-size: 24px;
    color: #999;
    text-align: center;
  }
}
</style>
